import { useMutation } from "@tanstack/react-query";
import { toast } from "react-toastify";
import CustomToast from "src/components/CustomToast/CustomToast";

import cmsClient from "src/services/cmsClient";

const updateObservationAnswer = async (
	payload: Partial<AdminObservationAnswer>
) => {
	const url = `/observations/admin/answers/${payload.id}/`;
	const response = await cmsClient.put<AdminObservationAnswer>(url, payload);

	return response.data;
};

const useUpdateObservationAnswer = () => {
	const onError = () =>
		toast.error(
			<CustomToast
				type="Error"
				message="There is an error updating the answer"
			/>,
			{
				autoClose: false
			}
		);

	const mutation = useMutation(updateObservationAnswer, { onError });

	return mutation;
};

export default useUpdateObservationAnswer;
